import React from "react";
import './App.css';
import { Route, Routes, Navigate } from "react-router-dom";
import { AuthContextProvider } from "./context/AuthContext";
import { ProtectedRoute, ProtectedRouteLogin } from "./components/ProtectedRoutes";
import Login from "./components/Login/LoginComponent";
import { MainView } from "./pages/MainView";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Dashboard from "./components/Dashboard/Dashboard"
import Emociones from "./components/Emociones/Emociones"
//FilterContext
import {FilterContextProvider} from "./context/FilterContext";

function App() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#002169",
      },
      secondary: {
        main: "#e2e2e2",
      },
      accent: {
        main: "#b1b5c1",
      },
    },
    typography: {
      fontFamily: ["Montserrat", "sans-serif"].join(","),
    },
  });
  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <AuthContextProvider>
        <FilterContextProvider>
          <Routes>
            <Route
              path="/login"
              element={
                <ProtectedRouteLogin>
                  <Login />
                </ProtectedRouteLogin>
              }
            />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <MainView />
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<Dashboard/>} />
              <Route path="/emociones" element={<Emociones/>} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Route>
          </Routes>
          </FilterContextProvider>
        </AuthContextProvider>
      </div>
    </ThemeProvider>
  );
}

export default App;
